import { ProfileRoles } from '@bp/pim-auth-constants';
import i18next from 'i18next';

export function getRoleNameTranslation(role: string) {
  switch (role) {
    case ProfileRoles.Parent:
      return i18next.t('common.parents');
    case ProfileRoles.Student:
      return i18next.t('students.title', { count: 1 });
    case ProfileRoles.Teacher:
      return i18next.t('persons.title', { count: 1 });
    case ProfileRoles.Other:
      return i18next.t('common.others');
    default:
      return i18next.t('common.unknown');
  }
}
